import {
  commonUrl,
  getRequest,
  ResponseDI,
} from "../../../base/services/urlService";
import AppStore from "../../../base/stores/AppStore";
import { checkExistUrl } from "../../general-content/services/content";
import {
  GetLessonsQueryParamsDI,
  Id,
  LessonDI,
  SerializedLessonsQueryParamsDI,
} from "../types";

type ResponseLesson = {
  lesson: Omit<LessonDI, "id | projectPartnerIds | lessonTags"> & {
    Id?: number;
    projectPartnerIds: Array<Id> | string;
    lessonTags: string;
    url: string;
  };
};

interface Params extends GetLessonsQueryParamsDI {
  lessonId: Id;
}

export const getLessonUrl = async (lessonUrl: string) => {
  const existLesson = AppStore.siteMapList.find((item) => item.url === lessonUrl);
  let lesson;

  if (existLesson) {
    lesson = await getLesson({ lessonId: existLesson.Id || existLesson.pageId });
    lesson.breadCrumbs = existLesson.breadCrumbs;
  } else {
    const lessonFromServer = await checkExistUrl(lessonUrl);
    lesson = await getLesson({ lessonId: lessonFromServer.pageId });
    lesson.breadCrumbs = lessonFromServer.breadCrumbs;
  }
  return lesson;
};

export const getLesson = async (params: Params): Promise<LessonDI> => {
  const url = `${commonUrl}/api/lesson/getLesson?lessonId=${params.lessonId}`;

  const { result } = await getRequest<ResponseDI<ResponseLesson>>(url);
  let adaptedTags: Array<Id>;
  if (!result.lesson.lessonTags.length) {
    adaptedTags = [];
  } else {
    adaptedTags = result.lesson.lessonTags.split(",");
  }
  const lesson: LessonDI = {
    ...result.lesson,
    id: result.lesson.Id,
    url: result.lesson.url,
    lessonTags: adaptedTags,
    projectPartnerIds: typeof result.lesson.projectPartnerIds === "string"
      ? result.lesson.projectPartnerIds.split(",")
      : result.lesson.projectPartnerIds,
  };
  return lesson;
};
